// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/notification.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/notification.proto.
 */
export const file_v1_notification: GenFile = /*@__PURE__*/
  fileDesc("ChV2MS9ub3RpZmljYXRpb24ucHJvdG8SAnYxImAKDE5vdGlmaWNhdGlvbhIKCgJpZBgBIAEoBRIPCgdjb250ZW50GAIgASgJEhMKC2NyZWF0ZV9kYXRlGAMgASgJEg8KB2lzX3JlYWQYBCABKAgSDQoFdGl0bGUYBSABKAkiKAoYTGlzdE5vdGlmaWNhdGlvbnNSZXF1ZXN0EgwKBHBhZ2UYASABKAUihAEKGUxpc3ROb3RpZmljYXRpb25zUmVzcG9uc2USJwoNbm90aWZpY2F0aW9ucxgBIAMoCzIQLnYxLk5vdGlmaWNhdGlvbhITCgt0b3RhbF9jb3VudBgCIAEoBRIUCgxjdXJyZW50X3BhZ2UYAyABKAUSEwoLdG90YWxfcGFnZXMYBCABKAUiFwoVR2V0VW5yZWFkQ291bnRSZXF1ZXN0Ii4KFkdldFVucmVhZENvdW50UmVzcG9uc2USFAoMdW5yZWFkX2NvdW50GAEgASgFMrQBChNOb3RpZmljYXRpb25TZXJ2aWNlElIKEUxpc3ROb3RpZmljYXRpb25zEhwudjEuTGlzdE5vdGlmaWNhdGlvbnNSZXF1ZXN0Gh0udjEuTGlzdE5vdGlmaWNhdGlvbnNSZXNwb25zZSIAEkkKDkdldFVucmVhZENvdW50EhkudjEuR2V0VW5yZWFkQ291bnRSZXF1ZXN0GhoudjEuR2V0VW5yZWFkQ291bnRSZXNwb25zZSIAQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_api_annotations]);

/**
 * @generated from message v1.Notification
 */
export type Notification = Message<"v1.Notification"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string create_date = 3;
   */
  createDate: string;

  /**
   * @generated from field: bool is_read = 4;
   */
  isRead: boolean;

  /**
   * @generated from field: string title = 5;
   */
  title: string;
};

/**
 * Describes the message v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_v1_notification, 0);

/**
 * @generated from message v1.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"v1.ListNotificationsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;
};

/**
 * Describes the message v1.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_v1_notification, 1);

/**
 * @generated from message v1.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"v1.ListNotificationsResponse"> & {
  /**
   * @generated from field: repeated v1.Notification notifications = 1;
   */
  notifications: Notification[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 current_page = 3;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 4;
   */
  totalPages: number;
};

/**
 * Describes the message v1.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_v1_notification, 2);

/**
 * @generated from message v1.GetUnreadCountRequest
 */
export type GetUnreadCountRequest = Message<"v1.GetUnreadCountRequest"> & {
};

/**
 * Describes the message v1.GetUnreadCountRequest.
 * Use `create(GetUnreadCountRequestSchema)` to create a new message.
 */
export const GetUnreadCountRequestSchema: GenMessage<GetUnreadCountRequest> = /*@__PURE__*/
  messageDesc(file_v1_notification, 3);

/**
 * @generated from message v1.GetUnreadCountResponse
 */
export type GetUnreadCountResponse = Message<"v1.GetUnreadCountResponse"> & {
  /**
   * @generated from field: int32 unread_count = 1;
   */
  unreadCount: number;
};

/**
 * Describes the message v1.GetUnreadCountResponse.
 * Use `create(GetUnreadCountResponseSchema)` to create a new message.
 */
export const GetUnreadCountResponseSchema: GenMessage<GetUnreadCountResponse> = /*@__PURE__*/
  messageDesc(file_v1_notification, 4);

/**
 * @generated from service v1.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * @generated from rpc v1.NotificationService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * @generated from rpc v1.NotificationService.GetUnreadCount
   */
  getUnreadCount: {
    methodKind: "unary";
    input: typeof GetUnreadCountRequestSchema;
    output: typeof GetUnreadCountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_notification, 0);

